<template>
	<div style="min-height: 910px;width:1200px;margin: 0 auto;">

		<div style="margin-top: 19px">
			<div class="bg_box">
				<div class="search_type_list">

					<span class="search_type_item">班级标签 ：</span>
					<span :class=ClassName @click="clickAll">全部</span>
					<span :class=" k==clickNum ? 'search_type_item active':'search_type_item' " v-for="(i,k) in tags"
						:key="k" @click="Click(k,i.id)">{{i.name}}</span>
				</div>
			</div>

			<div class="search_type_list bg_box">
				<span class="search_type_item">班级大类 ：</span>
				<span :class=ClassName2 @click="clickAll2">全部</span>
				<span :class=" k==clickNum2 || i.name==cate_name ? 'search_type_item active':'search_type_item' "
					v-for="(i,k) in cates" :key="k" @click="Click2(k,i.id)">{{i.name}}</span>
			</div>

			<div class="search_type_list bg_box">
				<span class="search_type_item">班级小类 ：</span>
				<span :class=ClassName3 @click="clickAll3">全部</span>
				<span
					:class=" k==clickNum3 || small_cate_name == i.name ? 'search_type_item active':'search_type_item' "
					v-for="(i,k) in smallcates" :key="k" @click="Click3(k,i.id)">{{i.name}}</span>
			</div>

			<div class="ov_course_content" style="text-align: center" v-if="classes.length<1">
				<el-empty description="无数据"></el-empty>
			</div>

			<div class="ov_course_content">
				<div class="grade_wrapper w" visible="true">

					<div class="web_course_list">
						<div v-for="(item,index) in classes" class="web_course_li" :key="index"
							@click="goDetail(item.id,item.name)">
							<div style="width: 280px;height: 156px;overflow: hidden;">
								<img class="web_course_img" :src="item.img ? item.img :  path" alt="">
							</div>
							<div style="height: 100px;background-color: #fff;">
								<p class="best_courses_p">{{item.name}}</p>
								<span class="web_course_pView">
									<p class="best_courses_p__p1"> {{item.class_type_name}}</p>
									<p class="best_courses_p__p2">￥{{item.price}}</p>
								</span>
							</div>
						</div>
					</div>

					<!--<div class="grade_main" >
              <a @click="goDetail(i.id,i.name)" class="grade_item_wrapper" v-for="(i,k) in classes" :key="k">
                <div class="grade_item" >
                  <div class="item_image_wrapper" >
                    <img class="item_image" :src=i.img >
                  </div>
                  <div class="grade_info" >
                    <div class="grade_name ellipsis" >{{i.name}}</div>
                    <div class="grade_teacher" >

                      <div class="teacher_warp_item">
                        {{i.class_type_name}}
                      </div>

                    </div>
                    <div class="grade_info_desc" >
                      <div class="learn_num" ></div>
                      <div class="price" >
                        <span class="current_price free" >￥{{i.price}}</span>
                       &lt;!&ndash; <span class="old_price">100</span>&ndash;&gt;
                      </div>
                    </div>
                  </div>
                </div>
              </a>
          </div>-->
				</div>
			</div>
			<div class="block">
				<el-pagination hide-on-single-page @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="queryForm.pageNo" :page-sizes="[12, 16, 20,24]" :page-size="queryForm.pageSize"
					layout="total, sizes, prev, pager, next, jumper" :total="totalNum">
				</el-pagination>
			</div>
		</div>



	</div>
</template>

<script>
	import {
		getClassTags,
		getClaes,
		getClassCate
	} from "../../api/moudles/user";

	export default {
		data() {
			return {

				totalNum: 0,
				ClassName: 'active search_type_item',
				ClassName2: 'active search_type_item',
				ClassName3: 'active search_type_item',
				columnCode: '',
				clickNum: null,
				clickNum2: null,
				clickNum3: null,
				tag: '',
				cate: '',
				cate_name: '',
				small_cate: '',
				small_cate_name: '',
				tags: [],
				cates: [],
				smallcates: [],
				classes: [{}],
				keyword: '',
				path: require('@/assets/img/course.png'),

				queryForm: {
					pageNo: 1,
					pageSize: 8
				}
			}
		},
		components: {

		},

		created() {

			console.log('created')


			if (typeof this.$route.query.parent_cate != "undefined") { //首页跳转

				this.cate = this.$route.query.parent_cate
			}

			if (typeof this.$route.query.parent_name != "undefined") { //首页跳转

				this.cate_name = this.$route.query.parent_name

				this.ClassName2 = 'search_type_item'
			}


			if (typeof this.$route.query.cate != "undefined") { //首页跳转

				this.small_cate = this.$route.query.cate
			}

			if (typeof this.$route.query.name != "undefined") { //首页跳转

				this.small_cate_name = this.$route.query.name
				this.ClassName3 = 'search_type_item'
			}

			if (typeof this.$route.query.keyword != "undefined") { //根据内容模糊查询

				this.keyword = this.$route.query.keyword
			}

			this.fetchData()
			this.getClaList()
			this.getSmallCate()
		},

		watch: {
			'$route': function() { //解决在当前页面输入内容页面无反应问题

				console.log('路由切换', this.$route.query.keyword)
				this.keyword = this.$route.query.keyword
				this.fetchData()
				this.getClaList()
				this.getSmallCate()

			}
		},

		methods: {

			handleSizeChange(val) {
				this.queryForm.pageSize = val;
				this.getClaList()

			},
			handleCurrentChange(val) {
				this.queryForm.pageNo = val;
				this.getClaList()

			},

			Click(k, id) {

				this.clickNum = k
				this.tag = id

				this.ClassName = 'search_type_item'

				this.getClaList()

			},
			Click2(k, id) {

				this.clickNum2 = k
				this.cate = id

				this.cate_name = ''
				this.ClassName2 = 'search_type_item'

				this.getSmallCate()
				this.getClaList()
			},

			Click3(k, id) {

				this.clickNum3 = k
				this.small_cate = id
				this.small_cate_name = ''
				this.ClassName3 = 'search_type_item'

				this.getClaList()
			},

			clickAll() {
				this.tag = ''
				this.clickNum = null
				this.ClassName = 'search_type_item active'
				this.getClaList()
			},
			clickAll2() { //大类的全部则将小类置为全部
				this.cate = ''
				this.clickNum2 = null
				this.ClassName2 = 'search_type_item active'
				this.cate_name = ''

				this.small_cate = ''
				this.small_cate_name = ''
				this.clickNum3 = null
				this.ClassName3 = 'search_type_item active'

				this.getClaList()
				this.getSmallCate()
			},

			clickAll3() {

				this.small_cate = ''
				this.small_cate_name = ''
				this.clickNum3 = null
				this.ClassName3 = 'search_type_item active'

				this.getClaList()
			},

			goDetail(id, name) {

				this.$router.push({
					path: '/classdetail',
					query: {
						id: id,
						name: name
					}
				})
			},

			getClaList() {
				getClaes({

					data: {
						tag: this.tag,
						cate: this.cate,
						small_cate: this.small_cate,
						keyword: this.keyword,
						pageNo: this.queryForm.pageNo,
						pageSize: this.queryForm.pageSize,
					},

					success: (res) => {

						console.log(res)

						this.classes = res.data
						this.totalNum = res.totalCount


					}

				})
			},

			fetchData() {

				getClassTags({

					data: {},

					success: (res) => {

						console.log(res)

						this.tags = res.data.tags
						this.cates = res.data.cates

					}

				})


			},

			getSmallCate() {
				getClassCate({
					data: {
						parentCate: this.cate
					},
					success: (res) => {
						console.log(res)
						this.smallcates = res.data
					}
				})

			}

		}
	}
</script>

<style>
	.bg_box {
		width: 100%;
		background-color: #fff;
		border-radius: 5px;
		padding: 5px 0px;
		margin-top: 10px;
	}

	.search_type_list {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
	}

	.search_type_list .search_type_item {
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		color: #333;
		cursor: pointer;
		margin-right: 10px;
		padding: 10px;
	}

	.search_type_list .search_type_item.active {

		color: #2256f6;
		font-weight: 700;
		background: rgba(34, 86, 246, .05);
		border-radius: 5px;
	}

	.ov_course_content {
		margin-top: 20px;
		margin-bottom: 20px;
	}

	.grade_wrapper {
		padding: 5px 0;
	}

	.w {
		width: 1200px;
		margin: auto;
	}

	.grade_main {
		display: flex;
		flex-wrap: wrap;
		margin-left: -10px;
		margin-right: -10px;
	}

	.grade_item_wrapper {
		margin-bottom: 20px;
		padding: 0 10px;
		width: 48.35%;
	}


	a {
		color: -webkit-link;
		cursor: pointer;
		text-decoration: none;
	}

	.grade_item {
		padding: 15px;
		display: flex;
		background: #ffffff;
		border-radius: 5px;
	}

	.item_image_wrapper {
		overflow: hidden;
		height: 128px;
		width: 230px;
		border-radius: 6px;
	}

	.item_image_wrapper .item_image {
		height: 100%;
		width: 100%;
		-o-object-fit: cover;
		object-fit: cover;
	}

	img,
	video {
		max-width: 100%;
		height: auto;
	}

	img,
	canvas,
	iframe,
	video {
		display: block;
		vertical-align: middle;
	}

	/*img {
  border-style: solid;
}*/


	.grade_info {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		flex: 1;
		padding-left: 10px;
	}

	.grade_name {
		font-weight: 500;
		font-size: 16px;
		line-height: 24px;
		height: 48px;
	}

	.ellipsis {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}

	.grade_teacher {
		white-space: nowrap;
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		color: #333;
		display: flex;
		align-items: center;
	}

	.grade_teacher {
		flex: 1;
		font-size: 12px;
		line-height: 18px;
		height: 42px;
		color: #999;
	}

	.teacher_warp_item {
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		cursor: pointer;
		margin-right: 10px;
	}

	.cover_teacher {
		width: 26px;
		height: 26px;
		border-radius: 50%;
		cursor: pointer;
	}

	img,
	video {
		max-width: 100%;
		height: auto;
	}

	img,
	canvas,
	iframe,
	video {
		display: block;
		vertical-align: middle;
	}

	/*
img {
  border-style: solid;
}
*/

	.teacher_warp_item .teacher_name {
		margin-top: 2px;
		font-size: 12px;
		line-height: 20px;
		width: 48px;
		text-align: center;
	}

	.tx-ov {
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}

	.grade_info_desc {
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 14px;
		white-space: nowrap;
		color: #999;
		line-height: 18px;
	}

	.price {
		line-height: 18px;
	}

	.price .current_price.free {
		color: #58b85c;
	}

	.price .current_price {
		font-size: 16px;
		font-weight: 550;
		color: #f61818;
	}

	.price .old_price {
		margin-left: 5px;
		font-size: 12px;
		line-height: 18px;
		color: #999;
		-webkit-text-decoration-line: line-through;
		text-decoration-line: line-through;
	}

	.grade_teacher {
		white-space: nowrap;
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		color: #333;
		display: flex;
		align-items: center;
	}

	.grade_teacher {
		flex: 1;
		font-size: 12px;
		line-height: 18px;
		height: 42px;
		color: #999;
	}

	/**滚动条的宽度*/
	::-webkit-scrollbar {
		width: 5px;
		height: 5px;
	}

	/*滚动条的滑块*/
	::-webkit-scrollbar-thumb {
		background-color: rgb(185, 221, 255);
		border-radius: 5px;
	}

	::-webkit-scrollbar-thumb:hover {
		background: rgba(24, 144, 255, .8);
	}

	/**
  精品课程
   */

	.web_course_list {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		grid-column-gap: 20px;
	}

	.web_course_li {
		width: 280px;
		border-radius: 8px;
		overflow: hidden;
		box-shadow: 0px 4px 10px 4px rgb(0 0 0 / 6%);
		margin-bottom: 27px;
	}

	.web_course_img {
		width: 280px;
		height: 156px;
		transition: all .3s;
	}

	.web_course_img:hover {
		transform: scale(1.1);
		cursor: pointer;
	}

	.web_course_pView {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 8px 18px 11px;
	}

	.web_course_pView__p {
		font-family: PingFangSC-Medium;
		font-size: 18px;
		color: #000000;
		letter-spacing: 0;
		text-align: left;
		font-weight: 500;
		line-height: 42px;
	}

	.normalFlex {
		display: flex;
		align-items: center;
	}

	.courseFlex {
		height: 50px;
		justify-content: space-between;
		padding-right: 12px;
		margin-bottom: 30px;
	}

	.view_father3 {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		grid-column-gap: 20px;
		margin: 30px 0;
	}

	.courseFlex_right {
		font-family: PingFangSC-Regular;
		font-size: 14px;
		color: #D40D16;
		letter-spacing: 0;
		text-align: center;
		line-height: 18px;
		font-weight: 400;
	}

	.courseFlex_right:hover {
		cursor: pointer;
		text-decoration: underline;
	}

	/* 精品课程 */
	.best_courses_p {
		font-family: PingFangSC-Regular;
		font-size: 16px;
		color: #000000;
		letter-spacing: 0;
		text-align: left;
		line-height: 26px;
		font-weight: 400;
		padding: 7px 18px 0px;
		
		word-break: break-all;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
	}

	.best_courses_p__p1 {
		font-family: PingFangSC-Regular;
		font-size: 14px;
		color: #999999;
		letter-spacing: 0;
		text-align: left;
		font-weight: 400;
	}

	.best_courses_p__p2 {
		font-family: AlibabaPuHuiTi-Bold;
		font-size: 18px;
		color: #E02020;
		letter-spacing: 0;
		text-align: right;
		font-weight: 700;
	}

	.course_box {
		cursor: pointer;
		width: 280px;
		height: 80px;
		background-image: linear-gradient(to right, #f2f8fe 100%, #ffffff 100%);
		border-radius: 1.33px;
		display: flex;
		align-items: center;
		justify-content: space-around;
		margin-bottom: 20px;
		border: 1px solid rgba(242, 244, 246, 1);
	}

	.course_box img {
		width: 44px;
		height: 44px;
	}

	.course_box p {
		font-size: 18px;
		letter-spacing: 0;
		text-align: center;
		font-weight: 600;
		font-family: PingFangSC-Medium;
		color: rgba(0, 0, 0, 0.85);
	}

	.zjxheader {
		height: 100px;
		width: 100%;
		background-color: #c01219;
	}

	.zjxheader_center {
		width: 1200px;
		margin: 0 auto;
		height: 100px;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.zjxheader_center__left {}

	.zjxheader_center__left_p {
		height: 50px;
		line-height: 50px;
		text-align: right;
		color: #fff;

		font-family: PingFangSC-Regular;
		font-size: 14px;
		letter-spacing: 0;
		font-weight: 400;
	}

	.zjxWarpList {
		width: 600px;
		height: 380px;
	}

	.zjxRightView {
		width: 590px;
		display: flex;
		justify-content: space-between;
	}

	.zjxRightView_left {
		background-color: #fff;
		width: 394px;
	}

	.zjxRightView_Right {
		width: 186px;
		display: flex;
		flex-flow: column;
		justify-content: space-between;
	}

	.zjxRightView_Right__view {
		height: 80px;
		width: 186px;
		color: #fff;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}

	.zjxRightView_Right__view p {
		margin-left: 14px;
	}

	.zjxRightView_Right__view:nth-child(odd) {
		background-color: #d40d16;
	}

	.zjxRightView_Right__view:nth-child(even) {
		background-color: #C19B61;
	}

	.zjx_course_span {
		display: inline-block;
		width: 5px;
		height: 24px;
		background: #0182FD;
	}

	.zjx_course_p {
		margin-left: 15px;
		font-size: 24px;
		letter-spacing: 0;
		font-weight: 600;
		font-family: PangMenZhengDao;
		color: #131415;
	}

	.grestProgrma {
		display: flex;
		justify-content: space-between;
	}

	.grestProgrma_view {
		display: flex;
		flex-flow: column;
		align-items: center;
		border: 1px solid rgba(219, 219, 219, 1);
		cursor: pointer;
		position: relative;
	}

	.grestProgrma_view img {
		width: 294px;
		height: 246px;
	}

	.grestProgrma_view p {
		display: inline-block;
		margin: 10px 0;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		width: 270px;
	}
</style>